document.addEventListener('DOMContentLoaded', () => {
  const nativeCartDrawer = document.querySelector('#Drawer-Cart');
  const footer = document.querySelector('footer');

  const rechargeCartDrawerHost = document.querySelector(
    '#recharge-storefront-experiences__cart-drawer'
  );
  const rechargeCartOverlayDrawerHost = document.querySelector(
    '#recharge-storefront-experiences__cart-overlay'
  );

  const cartDrawerShadowRoot = rechargeCartDrawerHost?.shadowRoot;
  const cartOverlayDrawerShadowRoot = rechargeCartOverlayDrawerHost?.shadowRoot;

  if (cartDrawerShadowRoot || cartOverlayDrawerShadowRoot) {
    // Function to refresh metafields by fetching the updated section
    const refreshMetafields = async () => {
      try {
        const response = await fetch(window.location.pathname + '?section_id=cart-drawer');
        const html = await response.text();

        // Parse HTML to extract metafields
        const parser = new DOMParser();
        const doc = parser.parseFromString(html, 'text/html');
        const metafieldsScript = doc.getElementById('cart-metafields-data');

        if (metafieldsScript) {
          window.productMetafields = JSON.parse(metafieldsScript.textContent);
        }
      } catch (error) {
        // Keep existing metafields on error
      }
    };

    // Function to inject cart-line-product-info into Recharge cart items
    const injectProductInfo = (shadowRoot) => {
      if (!shadowRoot) return;

      // Find cart items in Recharge shadow DOM (they use div.flex.flex-col with border-b)
      let cartItems = shadowRoot.querySelectorAll('section.w-full > div.flex.flex-col');

      cartItems.forEach((item) => {
        // Remove old info if exists (to refresh with new data)
        const oldInfo = item.querySelector('.cart-product-additional-info');
        if (oldInfo) {
          oldInfo.remove();
        }

        // Find the product title (p.font-semibold inside the item)
        const productTitle = item.querySelector('p.font-semibold');

        if (productTitle) {
          const titleText = productTitle.textContent.trim();

          // Find matching product by title
          let productHandle = null;
          for (const [handle, data] of Object.entries(window.productMetafields || {})) {
            if (data.title === titleText) {
              productHandle = handle;
              break;
            }
          }

          // Create the info element
          const infoDiv = document.createElement('div');
          infoDiv.className = 'cart-product-additional-info';
          infoDiv.style.cssText = 'font-size: 0.875rem; color: #4b5563; margin-top: 0.25rem; font-weight: 500;';

          if (productHandle) {
            // Get metafield data from window object (injected by Liquid)
            const servingContainer = window.productMetafields?.[productHandle]?.serving_container;

            if (servingContainer) {
              const label = window.servingContainerLabel || 'Počet dávek';
              infoDiv.textContent = `${label}: ${servingContainer}`;
              // Insert after product title only if metafield exists
              productTitle.parentNode.insertBefore(infoDiv, productTitle.nextSibling);
            }
          }
        }
      });
    };

    let debounceTimer;
    let lastCartItemCount = 0;
    let isFetching = false;

    const observer = new MutationObserver(() => {
      // Check current cart item count
      const currentCartItems = (cartDrawerShadowRoot?.querySelectorAll('section.w-full > div.flex.flex-col').length || 0) +
                               (cartOverlayDrawerShadowRoot?.querySelectorAll('section.w-full > div.flex.flex-col').length || 0);

      // Only refresh metafields if cart item count changed (product added/removed)
      const cartItemsChanged = currentCartItems !== lastCartItemCount;
      const isFirstLoad = lastCartItemCount === 0 && currentCartItems > 0;

      // Debounce to avoid too many updates
      clearTimeout(debounceTimer);
      debounceTimer = setTimeout(async () => {
        if (cartItemsChanged && !isFetching) {
          isFetching = true;
          lastCartItemCount = currentCartItems;
          await refreshMetafields();
          isFetching = false;
        }
        injectProductInfo(cartDrawerShadowRoot);
        injectProductInfo(cartOverlayDrawerShadowRoot);
      }, isFirstLoad ? 100 : 300); // Shorter delay on first load
      const cartDrawerButton = cartDrawerShadowRoot?.querySelector('button');
      const cartOverlayDrawerButton =
        cartOverlayDrawerShadowRoot?.querySelector('button svg');

      const buttonExists = cartDrawerButton || cartOverlayDrawerButton;

      if (buttonExists && nativeCartDrawer?.hasAttribute('open')) {
        requestAnimationFrame(() => {
          const recheckDrawerButton =
            cartDrawerShadowRoot?.querySelector('button');
          const recheckOverlayButton =
            cartOverlayDrawerShadowRoot?.querySelector('button svg');

          if (recheckDrawerButton || recheckOverlayButton) {
            nativeCartDrawer.removeAttribute('open');
            footer?.setAttribute('data-aria-hidden', 'true');

            if (recheckOverlayButton) {
              recheckOverlayButton.style.color = '#fff';
            }
          }
        });
      }

      if (!buttonExists) {
        footer?.removeAttribute('data-aria-hidden');
      }
    });

    if (cartDrawerShadowRoot) {
      observer.observe(cartDrawerShadowRoot, {
        childList: true,
        subtree: true,
      });
    }

    if (cartOverlayDrawerShadowRoot) {
      observer.observe(cartOverlayDrawerShadowRoot, {
        childList: true,
        subtree: true,
      });
    }

    // Initial injection with delay to ensure metafields are loaded
    const tryInject = async () => {
      if (window.productMetafields) {
        injectProductInfo(cartDrawerShadowRoot);
        injectProductInfo(cartOverlayDrawerShadowRoot);
      } else {
        // If metafields not loaded yet, try to fetch them
        await refreshMetafields();
        injectProductInfo(cartDrawerShadowRoot);
        injectProductInfo(cartOverlayDrawerShadowRoot);
      }
    };

    // Try injection sooner for better UX
    setTimeout(tryInject, 200);
  }
});
